import { SnackbarProvider } from '@/design-system';
import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AutenticatedLayout from './AuthenticatedLayout';
import NonAutenticatedLayout from './NonAuthenticatedLayout';
import { PeachjarLoader } from './components';
import AuthenticationContext from './context/AuthenticationContext';
import { useIsEmbed } from './hooks';
import { EmbedRoutes } from './routes/EmbedRoutes';

function App() {
  const location = useLocation();
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then(registration => {
        registration.update();
      });
    }
  }, [location]);

  const { isAuthenticated, isLoading } = useContext(AuthenticationContext);

  if (isLoading) return <PeachjarLoader />;

  const isEmbedded = useIsEmbed();

  if (isEmbedded) {
    return <EmbedRoutes />;
  }

  return (
    <>
      {isAuthenticated ? <AutenticatedLayout /> : <NonAutenticatedLayout />}
      <SnackbarProvider />
    </>
  );
}

export default App;
